var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: "36px",
    height: "35px",
    viewBox: "0 0 300 300",
    enableBackground: "new 0 0 300 300",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#010101",
    strokeWidth: 12,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M228,270.2c0,9.9-8.1,18-18,18H90c-9.9,0-18-8.1-18-18v-240c0-9.9,8.1-18,18-18h120c9.9,0,18,8.1,18,18V270.2z"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#010101",
    strokeWidth: 12,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 78,
    y1: 60.2,
    x2: 222,
    y2: 60.2
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#010101",
    strokeWidth: 12,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 146.6,
    y1: 36.2,
    x2: 146.6,
    y2: 36.2
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#010101",
    strokeWidth: 12,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 138,
    y1: 264.2,
    x2: 162,
    y2: 264.2
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#010101",
    strokeWidth: 12,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 78,
    y1: 240.2,
    x2: 222,
    y2: 240.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#010101",
    strokeWidth: 12,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M155.5,105.1c-24.2,0-43.8,16.3-43.8,36.5c0,9.8,4.6,18.6,12.1,25.2c-3.8,9.6-9.8,19.6-19.7,26.5c19.5,0,32.6-6.6,40-16.5 c3.6,0.8,7.4,1.3,11.3,1.3c24.2,0,43.8-16.3,43.8-36.5C199.3,121.4,179.7,105.1,155.5,105.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSms);
export default __webpack_public_path__ + "static/media/Icon_Sms.9f0eb47676451602bde8f7408af8e2cc.svg";
export { ForwardRef as ReactComponent };